module.exports = __webpack_public_path__ + "img/hr-rock-big-02.fa50b422.png";